import { createReducer } from '@reduxjs/toolkit';

import {
  fetchLearnerFinalSummary,
  setShowLearnerTakeaway,
  setLearnerFinalSummaryReady,
  setLearnerTakeawayAutoShown,
} from 'redux/actions/learner-final-summary';
import { LearnerFinalSummaryStatus } from 'redux/schemas/app/learner-final-summary';
import { initialRootState } from '.';

/**
 * Reducer for the learner end-of-course AI takeaway. Operates on the shared root
 * state (combined via reduceReducers) and only touches `app.learnerFinalSummary`.
 */
export default createReducer(initialRootState, (builder) => {
  builder
    .addCase(fetchLearnerFinalSummary.pending, (state) => {
      state.app.learnerFinalSummary.isLoading = true;
      state.app.learnerFinalSummary.errorMessage = null;
    })
    .addCase(fetchLearnerFinalSummary.fulfilled, (state, action) => {
      const { status, report, errorMessage } = action.payload ?? ({} as any);
      state.app.learnerFinalSummary.isLoading = false;
      state.app.learnerFinalSummary.status = status ?? null;
      state.app.learnerFinalSummary.report = report ?? null;
      state.app.learnerFinalSummary.errorMessage = errorMessage ?? null;
    })
    .addCase(fetchLearnerFinalSummary.rejected, (state, action) => {
      state.app.learnerFinalSummary.isLoading = false;
      state.app.learnerFinalSummary.status = LearnerFinalSummaryStatus.Failed;
      state.app.learnerFinalSummary.errorMessage = action.error?.message ?? 'error';
    })
    .addCase(setLearnerFinalSummaryReady, (state, action) => {
      state.app.learnerFinalSummary.status = LearnerFinalSummaryStatus.Ready;
      state.app.learnerFinalSummary.report = action.payload;
      state.app.learnerFinalSummary.isLoading = false;
      state.app.learnerFinalSummary.errorMessage = null;
    })
    .addCase(setShowLearnerTakeaway, (state, action) => {
      state.app.learnerFinalSummary.show = action.payload;
    })
    .addCase(setLearnerTakeawayAutoShown, (state, action) => {
      state.app.learnerFinalSummary.autoShown = action.payload;
    });
});
